import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
import { font } from './Montserrat-normal';
import { getScreenShot, takeScreenshot } from '@/lib/takeScreenshot';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { logo } from '@/pdf/logo64';
import { line } from '@/pdf/line';
import { useStoreData } from '@/Store/storeData';
import { $ } from '@/Engine/state';
import { useUIOnlyStore } from '@/Store/storeUI';
import { requestJsonGet } from '@/utils/httpRequest';


let positionY = 10;
const fontNormal = 15;
const fontMini=10;
let docWidth=0;
let docHeight=0;
const paddingLeft=14;
const paddingBottom=15;
const itemsPerPage=17;
let textGap=6;
let priceImageSize=11;
let baseTableItemHeight=10;
let itemTextXpos=45;
let pageCount=0;
let doc = {};

export async function createPdf(itemsArr, currencySymbol, externalUser) {

    // const requestOptions = {
    //     method: 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    // };
    //
    // const response = await fetch(url, requestOptions);
    // const responseJson = await response.text();
    // return JSON.parse(responseJson);
    // window.configurator.postMessage({ configurator: { action: 'setContacts' }, data: {} }, '*');

    let items=[ ...itemsArr ];
    if (items === null) {
        return;
    }
    positionY = 10;
    doc=new jsPDF({
        // orientation: 'l',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts: true,
    });
    //Setup
    docWidth=doc.internal.pageSize.getWidth();
    docHeight=doc.internal.pageSize.getHeight();
    doc.addFileToVFS('Montserrat.ttf', font);
    doc.addFont('Montserrat.ttf', 'Montserrat', 'normal');
    doc.setFont('Montserrat');
    doc.setFontSize(fontNormal);
    //Scene screen
    pageCount=1;
    let contacts=window.contacts;
    if (!contacts) contacts={
        address:'',phones:'',emails:'',url:'',logo:'',company_name: '',
    };
    console.log(contacts);
    addLogo();
    doc.text('Ваш проект ' + useConfigurationStore().getProjectName + ':', paddingLeft, positionY, null, null);
    nextTextLine();
    let dateTime = new Date();
    doc.text('Проект создан ' + dateTime.toLocaleDateString('en-GB') + ' в ' + dateTime.toLocaleTimeString(), paddingLeft, positionY, null, null);
    nextTextLine();
    let screenScans=[];

    useUIOnlyStore().setLoader(true);
    takeScreenshot();
    await window.wardrobe.moveCamera('front');
    if(useConfigurationStore().room.frontWallWidth>0 && !$.room.isEmpty('front'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('front')/$.room.getHeight('front') });
    await window.wardrobe.moveCamera('left');
    if(useConfigurationStore().room.leftWallWidth>0 && !$.room.isEmpty('left'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('left')/$.room.getHeight('left') });
    await window.wardrobe.moveCamera('right');
    if(useConfigurationStore().room.rightWallWidth>0 && !$.room.isEmpty('right'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('right')/$.room.getHeight('right') });
    await window.wardrobe.moveCamera('back');
    if(useConfigurationStore().room.backWallWidth>0 && !$.room.isEmpty('back'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('back')/$.room.getHeight('back') });
    await window.wardrobe.moveCamera('standard');

    useUIOnlyStore().setLoader(false);
    let screenImage = new Image();
    screenImage.src = window.screen__img;
    const screenHeight=(document.documentElement.clientHeight/document.documentElement.clientWidth)*(docWidth-paddingLeft*2);
    doc.addImage(screenImage, 'PNG', paddingLeft, positionY, docWidth-paddingLeft*2, screenHeight);
    positionY+=screenHeight;
    nextTextLine();
    doc.text('Стоимость проекта: ' + useStoreData().getCost + ' ' + currencySymbol, paddingLeft, positionY, null, null);
    nextPage();
    screenScans.forEach((screen,index)=>{
        const standart=230;
        const widthLim=docWidth-paddingLeft*2;
        let imgFrameWidth= standart*screen.aspect;
        let imgFrameHeight=standart;
        if(imgFrameWidth>widthLim) {
            const newScale=imgFrameWidth/widthLim;
            imgFrameWidth=widthLim;
            imgFrameHeight=imgFrameHeight/newScale;
        }
        doc.text('Развертка стены ' + (index+1), paddingLeft, positionY, null, null);
        nextTextLine();
        doc.addImage(screen.imagePath, 'PNG', paddingLeft, positionY, imgFrameWidth, imgFrameHeight);
        nextTextLine();
        nextPage();
    });
    //Price list
    //Make header
    // doc.text('Комплектация:', paddingLeft, positionY, null, null);
    positionY+=5;
    doc.setFontSize(fontMini);
    let pos = 0;
    if (externalUser) {
        pos = 15;
        doc.text('ID', pos, positionY);
    }
    doc.text('Фото', 15 + pos, positionY);
    doc.text('Товар', 47, positionY);
    doc.text('Габариты', 97, positionY);
    doc.text('Вес', 126, positionY);
    doc.text('Цена за шт', 139, positionY);
    doc.text('Кол-во', 163, positionY);
    doc.text('Сумма', 180, positionY);
    positionY+=5;
    addLine();
    //joska
    let finalPrice=0;
    let finalMass=0;
    let maxSize=0;
    items.push(...useStoreData().getAccessories);
    // positionY+=3;
    items.forEach((item, index) => {
        addTableItem(item,index,!!externalUser,pos,currencySymbol);
        //Считаем итоги
        finalPrice += item.count * item.price;
        finalMass += (+item.weigth * item.count);
        if (item.width > maxSize) maxSize = item.width;
        if (item.height > maxSize) maxSize = item.height;
        if (item.depth > maxSize) maxSize = item.depth;

        // Увеличиваем позицию с учетом дополнительной высоты текста
        // (index + 1) % itemsPerPage === 0
        if ((positionY+baseTableItemHeight)>=(docHeight-paddingBottom)) {
            positionY = 0;
            nextPage();
        } else if (index + 1 !== items.length) addLine();

    });
    addLine();
    //Общая цена, общий вес, максимальный габарит
    nextTextLine(12);
    doc.setFontSize(fontNormal);
    doc.text('' + finalPrice+' ' + currencySymbol, docWidth-paddingLeft-getTextSize('' + finalPrice+' ' + currencySymbol), positionY);
    doc.setFontSize(fontMini);
    nextTextLine(6);
    doc.text('Общий вес', docWidth-paddingLeft-getTextSize('Общий вес'), positionY);
    nextTextLine(6);
    finalMass = parseInt(finalMass * 100);
    finalMass = '' + parseInt(finalMass / 100) + '.' + parseInt(finalMass % 100);
    doc.text('' + finalMass+' кг.',docWidth-paddingLeft-getTextSize('' + finalMass+' кг.'), positionY);
    nextTextLine(6);
    // doc.text('' + finalPrice+' руб.', 169, positionY);
    nextTextLine(6);
    doc.text('Максимальный габарит заказа', docWidth-paddingLeft-getTextSize('Максимальный габарит заказа'), positionY);
    nextTextLine(6);
    doc.text('' + getTrueSize(maxSize) +' мм',docWidth-paddingLeft-getTextSize('' + maxSize+' мм'), positionY);
    nextTextLine(6);
    //Дополнительная информация
    addLine();
    nextTextLine(12);
    if (contacts.logo && contacts.logo.length) {
        doc.addImage(contacts.logo, 'PNG', paddingLeft, positionY, 35, 10);
        nextTextLine(24);
    }
    if (contacts.company_name && contacts.company_name.length) {
        doc.text('Название компании:', paddingLeft, positionY);
        nextTextLine(6);
        doc.text(contacts.company_name, paddingLeft, positionY);
        nextTextLine(6);
    }
    doc.text('Адрес:', paddingLeft, positionY);
    nextTextLine(6);
    doc.text(contacts.address, paddingLeft, positionY);
    nextTextLine(6);
    doc.text('Телефон:', paddingLeft, positionY);
    nextTextLine(6);
    // let currentPaddingLeft=paddingLeft;
    // contacts.phones.forEach(phone=>{
    //     doc.text(phone, currentPaddingLeft, positionY);
    //     currentPaddingLeft+=(doc.getTextWidth(phone)+5);
    // });
    // currentPaddingLeft=paddingLeft;
    doc.text(contacts.phones, paddingLeft, positionY);
    nextTextLine(6);
    doc.text('Email', paddingLeft, positionY);
    nextTextLine(6);
    doc.text(contacts.emails, paddingLeft, positionY);
    // contacts.emails.forEach(email=>{
    //     doc.text(email, currentPaddingLeft, positionY);
    //     currentPaddingLeft+=(doc.getTextWidth(email)+5);
    // });
    nextTextLine(6);
    doc.text(contacts.url, paddingLeft, positionY);
    nextTextLine(12);
    addLine();
    addNumerification();
    return doc;
}

function addLogo() {
    doc.addImage(logo, 'PNG', paddingLeft, positionY, 35, 10);
    nextTextLine();
    nextTextLine();
}
function nextTextLine(customGap=10) {
    if((positionY+customGap)>=(docHeight-paddingBottom)){
        nextPage();
    } else positionY += customGap;
}
function addLine() {
    doc.setDrawColor(0); // устанавливаем цвет линии на чёрный
    doc.setLineWidth(0.3); // устанавливаем ширину линии
    doc.line(paddingLeft, positionY, doc.internal.pageSize.width - paddingLeft,positionY); // рисуем линию от 10 пунктов слева до ширины листа минус 10 пунктов
}

function addTableItem(item,index,isExternalUser,posX,currencySymbol){
    if (isExternalUser) {
        //ID
        doc.text(item.myId ? item.myId.toString() : 'null', 15, positionY + 8);
    }

    //Изображение
    if (item.image !== '') {
        let img = new Image();
        img.src = item.image;
        try {
            doc.addImage(img, 'PNG', 14 + posX, positionY + 2, priceImageSize, priceImageSize);
        } catch (error) {
            console.error('Ошибка при добавлении изображения:', item.name, img);
        }
    }

    positionY += 8;

    //Название - получаем дополнительную высоту
    const additionalHeight = addItemTitle(item.name, posX);

    //Габариты
    doc.text(getTrueSize(item.width) + 'x' + getTrueSize(item.height) + 'x' + getTrueSize(item.depth) + ' мм', 93, positionY);
    //Вес
    doc.text(item.weigth + ' кг.', 123, positionY);
    //Цена
    doc.text(item.price + ' ' + currencySymbol, 141, positionY);
    //Количество
    doc.text('' + item.count, 169, positionY);
    //Общая стоимость
    doc.text('' + item.count * item.price + ' ' + currencySymbol, 181, positionY);

    positionY += (priceImageSize - 5) + additionalHeight;
}

function nextPage() {
    doc.addPage();
    positionY = 10;
    addLogo();
    pageCount+=1;
}
export async function getBase64PDF(items, currencySymbol, externalUser) {
    return new Promise(function(resolve, reject) {
        createPdf(items, currencySymbol, externalUser).then(doc => {
            const base64data = doc.output('datauristring');
            resolve(base64data);
        }).catch((err) => {
            reject(err);
        });
    });
}
function addNumerification() {
    positionY = docHeight - 8;
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(fontMini);
        const line='Страница: ' + i + ' из ' + pageCount;
        const lineWidth=doc.getTextWidth('Страница: ' + i + ' из ' + pageCount);
        doc.text(line,(docWidth/2)-(lineWidth/2),positionY);
    }
}
// Функция для разделения текста на строки по заданной ширине
function splitTitleToFitWidth(title, columnWidth) {
    const parts = title.split(' ');
    let currentLine = '';
    const resultParts = [];

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const newLine = currentLine + (currentLine ? ' ' : '') + part;

        if (doc.getTextWidth(newLine) > columnWidth - 10) {
            if (currentLine) {
                resultParts.push(currentLine);
                currentLine = part;
            } else {
                // Если одно слово превышает ширину столбца
                resultParts.push(part);
                currentLine = '';
            }
        } else {
            currentLine = newLine;
        }
    }

    // Добавление последней строки, если она существует
    if (currentLine) {
        resultParts.push(currentLine);
    }

    return resultParts;
}

function addItemTitle(title, pos) {
    const columnWidth = 55;
    const columnStartX = 30 + pos;
    const lineHeight = 5; // Высота одной строки текста
    const baseHeight = 8; // Базовая высота для одного товара

    const titleWidth = doc.getTextWidth(title);

    if (titleWidth >= columnWidth - 7) {
        // Автоперенос по пробелу
        const resultParts = splitTitleToFitWidth(title, columnWidth);

        // Вычисляем необходимую высоту для текста
        const textHeight = resultParts.length * lineHeight;

        // Рисуем каждую строку
        resultParts.forEach((part, index) => {
            doc.text(part, columnStartX, positionY - 2.5 + (index * lineHeight));
        });

        // Возвращаем дополнительную высоту, которую занял текст
        const additionalHeight = Math.max(0, textHeight - baseHeight);
        return additionalHeight;
    } else {
        // Одна строка - используем текущую позицию
        doc.text(title, columnStartX, positionY);
        return 0;
    }
}
function getTextSize(text){
    return doc.getTextWidth(text);
}
function getTrueSize(size){
    return (size*1000).toFixed(0);
}
export const loadResultPDF = function(items, currencySymbol, externalUser) {
    return new Promise(function(resolve, reject) {
        createPdf(items, currencySymbol, externalUser).then(doc => {
            doc.save(useConfigurationStore().getProjectName+' отчёт.pdf');
            positionY=10;
            resolve();
        }).catch((err) => {
            reject(err);
        });
    });
};

